
import { useIntl as useReactIntl, FormattedMessage, injectIntl } from 'react-intl';
import {
  getLocale,
  setLocale,
  addLocale,
  getAllLocales,
  getIntl,
} from './runtime';

export { FormattedMessage, injectIntl, getLocale, setLocale, addLocale, getAllLocales, getIntl };

export function useIntl() {
  try {
    return useReactIntl();
  } catch (e) {
    return getIntl();
  }
}
